/**
 * rendi-progress-bar — wizard progress indicator.
 *
 * Renders the track/fill and an optional step counter. The fill reflects the
 * step currently in view (position), not the answer state, so the bar never
 * advances on an answer alone. Exposes setProgress so the host form drives it
 * without reaching into the internals. The counter is shown only when the host
 * asks for it (`showCount`): it carries a fixed total, so it's reserved for the
 * deterministic no-orders flow where that total never shifts.
 */
if (!customElements.get('rendi-progress-bar')) {
  class RendiProgressBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-progress-track]');
      this.fill = this.querySelector('[data-progress-fill]');
      this.counter = this.querySelector('[data-progress-counter]');
    }

    setProgress({ current, total, showCount }) {
      const safeTotal = Math.max(1, Math.round(Number(total) || 1));
      const safeCurrent = Math.max(1, Math.min(safeTotal, Math.round(Number(current) || 1)));
      const percent = Math.round((safeCurrent / safeTotal) * 100);

      if (this.fill) {
        this.fill.style.width = `${percent}%`;
      }
      if (this.track) {
        this.track.hidden = false;
        this.track.setAttribute('aria-valuenow', String(percent));
      }
      if (this.counter) {
        this.counter.hidden = !showCount;
        if (showCount) {
          this.counter.textContent = `${safeCurrent}/${safeTotal}`;
        }
      }
    }
  }

  customElements.define('rendi-progress-bar', RendiProgressBar);
}
